import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=aeff1664&scoped=true&"
import script from "./Campaigns.vue?vue&type=script&lang=ts&"
export * from "./Campaigns.vue?vue&type=script&lang=ts&"
import style0 from "./Campaigns.vue?vue&type=style&index=0&id=aeff1664&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeff1664",
  null
  
)

export default component.exports